import apiClient from '../../../shared/api/client';
import type {
  GetUserPublicationsParams,
  MapCityItem,
  OffersMapSummary,
  PaginatedPublications,
} from '../types/publication.types';

const publicationService = {
  async getUserPublications(params?: GetUserPublicationsParams): Promise<PaginatedPublications> {
    return apiClient.get<PaginatedPublications>('/offers/me', { params });
  },

  async getRecentPublications(): Promise<PaginatedPublications['data']> {
    return apiClient.get<PaginatedPublications['data']>('/offers/recent');
  },

  async getMapSummary(): Promise<OffersMapSummary> {
    return apiClient.get<OffersMapSummary>('/offers/map-summary');
  },

  async getMapCities(query?: string, limit = 50): Promise<MapCityItem[]> {
    const params = new URLSearchParams();
    params.set('limit', String(limit));

    if (query?.trim()) {
      params.set('q', query.trim());
    }

    return apiClient.get<MapCityItem[]>(`/offers/map-cities?${params.toString()}`);
  },
};

export default publicationService;
